const ListingModeEnum = {
  ROOTS_ONLY: 'ROOTS_ONLY',
  LEAVES_ONLY: 'LEAVES_ONLY',
  ALL: 'ALL',
};

export default ListingModeEnum;
